import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=f0254b20&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=f0254b20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0254b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0254b20')) {
      api.createRecord('f0254b20', component.options)
    } else {
      api.reload('f0254b20', component.options)
    }
    module.hot.accept("./PdfViewer.vue?vue&type=template&id=f0254b20&scoped=true", function () {
      api.rerender('f0254b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PdfViewer.vue"
export default component.exports